const comments = [
  { id: 1, name: '吃瓜不嫌事大', content: '这个瓜也太大了，连夜刷完所有相关视频，黑料吃瓜网果然从不让人失望！每天打开第一时间就看有没有新的爆料。', time: '2小时前', likes: 328 },
  { id: 2, name: '娱乐圈观察员', content: '这波料太猛了，连我这种老吃瓜群众都惊了。黑料吃瓜不打烊真的说到做到，半夜三点还在更新，太拼了。', time: '5小时前', likes: 256 },
  { id: 3, name: '匿名吃瓜人', content: '从别的地方看到的爆料不全，来这里才算真正吃明白了。吃瓜黑料合集的整理太到位了，时间线清清楚楚。', time: '8小时前', likes: 189 },
  { id: 4, name: '深夜瓜田守望者', content: '作为资深吃瓜群众，黑料吃瓜在线观看体验是真的好，视频加载快还没广告，比某些平台良心一万倍。', time: '昨天', likes: 412 },
  { id: 5, name: '八卦小能手', content: '最近网红翻车的料一个比一个劲爆，黑料最新爆料的更新速度堪称全网第一，我已经推荐给身边所有朋友了。', time: '昨天', likes: 173 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              吃瓜热评
            </h2>
          </div>

          <div className="space-y-4">
            {comments.map((c) => (
              <div
                key={c.id}
                className="p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 font-bold text-sm">
                    {c.name.charAt(0)}
                  </div>
                  <div>
                    <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                    <span className="ml-2 text-[11px] text-foreground-400">{c.time}</span>
                  </div>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">{c.content}</p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{c.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}